import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "mm4s-sections-seen";

export const SectionTracker = () => {
  useEffect(() => {
    const seen = new Set(JSON.parse(sessionStorage.getItem(KEY) || "[]"));
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const id = e.target.id;
        if (!e.isIntersecting || seen.has(id)) return;
        seen.add(id);
        sessionStorage.setItem(KEY, JSON.stringify([...seen]));
        obs.unobserve(e.target);
        axios.post(`${API}/track/section`, { section: id }).catch(() => {});
      });
    }, { threshold: 0.25 });
    document.querySelectorAll("main section[id]").forEach((s) => { if (!seen.has(s.id)) obs.observe(s); });
    return () => obs.disconnect();
  }, []);
  return null;
};
